function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 338,
  height: 55
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("text", {
  transform: "translate(3 43)",
  fill: "#3a9577",
  fontSize: 44,
  fontFamily: "Inter",
  fontWeight: 700,
  letterSpacing: "0.009em",
  opacity: 0.676
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Just"), /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fill: "#bababa"
}, "Contribute")), /*#__PURE__*/React.createElement("text", {
  transform: "translate(0 43)",
  fill: "#4ecca3",
  fontSize: 44,
  fontFamily: "Inter",
  fontWeight: 700,
  letterSpacing: "0.009em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Just"), /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fill: "#eee"
}, "Contribute")));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 40,
    viewBox: "0 0 338 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.fae23239.svg";
export { ForwardRef as ReactComponent };